import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import ModalList from './ModalList';
import ModalTable from './ModalTable';
import { popProperty } from '../../util/general';

const keymap = r => Object.keys(r).map(k => r[k]);

const operationHeaders = [
  {
    text: 'Opr',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Labor Type',
    width: 95,
    maxWidth: 100,
    className: 'text-center',
  },
  {
    text: 'Details',
    width: 700,
  },
];

const partHeaders = [
  {
    text: 'Opr',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Line #',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Qty',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Division',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Part #',
    width: 155,
  },
  {
    text: 'Description',
    width: 115,
  },
  {
    text: 'Initials',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Trade',
    width: 85,
    className: 'text-right',
  },
  {
    text: 'Net',
    width: 85,
    className: 'text-right',
  },
];

const historyHeaders = [
  {
    text: 'Repair Order',
    width: 85,
    className: 'text-center',
  },
  {
    text: 'Open Date',
    width: 85,
    className: 'text-center',
  },
  {
    text: 'Customer',
    width: 85,
    className: 'text-center',
  },
  {
    text: 'Name',
    width: 155,
  },
  {
    text: 'Status',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Date Closed',
    width: 85,
    className: 'text-center',
  },
];

const EstimateHistory = ({ lookupKey, view }) => {
  const [loading, setLoading] = useState(true);
  const [primaryData, setPrimaryData] = useState({});

  const getData = () => {
    setLoading(true);

    ApiService.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}`)
      .then(response => {
        const { data } = response.data;

        let specs;
        try {
          specs = JSON.parse(data) || {};
        } catch (err) {
          console.warn('Parse failed', err);
        }

        if (!specs) {
          return;
        }

        specs.estimateHistory = specs.estimateHistory ? specs.estimateHistory.map(keymap) : [];
        specs.operations = specs.operations ? specs.operations.map(keymap) : [];
        specs.parts = specs.parts ? specs.parts.map(keymap) : [];

        setPrimaryData(specs);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div>
      <Row>
        <Col md={12}>
          <ModalList data={primaryData.details} columns={2} />
          {/* {notes.map(note => <div>Date {note.date} | Author {note.author} | Msg {note.msg}</div>)} */}
        </Col>
      </Row>

      <Row>
        <Col md={12} lg={12} xl={12}>
          <div className="h5 mb-0 mt-2 p-1">Operations</div>
          <hr className="mt-0 mb-2" />
          <ModalTable
            hideToolbar
            headers={operationHeaders}
            data={primaryData.operations}
            style={{ height: '200px' }}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12} lg={12} xl={12}>
          <div className="h5 mb-0 mt-2 p-1">Parts</div>
          <hr className="mt-0 mb-2" />
          <ModalTable hideToolbar headers={partHeaders} data={primaryData.parts} style={{ height: '250px' }} />
        </Col>
      </Row>

      <Row>
        <Col md={12} lg={12} xl={12}>
          <div className="h5 mb-0 mt-2 p-1">Estimate Usage</div>
          <hr className="mt-0 mb-2" />
          <ModalTable hideToolbar headers={historyHeaders} data={primaryData.estimateHistory} style={{ height: '200px' }} />
        </Col>
      </Row>

    </div>
  );
};

EstimateHistory.propTypes = {
  lookupKey: PropTypes.string,
  view: PropTypes.string,
};

export default EstimateHistory;
